module.exports = __webpack_public_path__ + "img/commerce-cloud-logo.e4cd2d87.svg";